import { Button } from "@/components/ui/button";
import { Mail, Linkedin, Copy, Check, Send, Loader2 } from "lucide-react";

const CopyButton = ({ copied, onClick }) => (
  <Button size="sm" variant="outline" onClick={onClick} className="border-gray-700 text-white hover:bg-white/10">
    {copied ? <Check className="h-3 w-3 text-green-400" /> : <Copy className="h-3 w-3" />}
    <span className="ml-1 text-xs">Copy</span>
  </Button>
);

export const ProspectOutreach = ({ idx, outreach, company, copiedField, sendingEmail, onCopy, onSendEmail }) => {
  const linkedinText = outreach.linkedin?.followUpMessage || outreach.linkedin?.connectionRequest;
  return (
    <div className="mt-4 space-y-4">
      <div className="bg-black/30 rounded-lg p-4 border border-gray-700">
        <div className="flex items-center justify-between mb-3">
          <h5 className="text-white font-semibold flex items-center gap-2"><Mail className="h-4 w-4 text-ism-teal" />Email Outreach</h5>
          <div className="flex gap-2">
            <CopyButton copied={copiedField === `email-${idx}`} onClick={() => onCopy(`Subject: ${outreach.email?.subject}\n\n${outreach.email?.body}`, `email-${idx}`)} />
            <Button size="sm" onClick={() => onSendEmail(outreach, company, idx)} disabled={sendingEmail} className="bg-ism-teal hover:bg-ism-teal-dark text-white">
              {sendingEmail ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />}
              <span className="ml-1 text-xs">Send</span>
            </Button>
          </div>
        </div>
        {outreach.email?.subject && (
          <div className="mb-3 pb-2 border-b border-gray-700">
            <span className="text-gray-500 text-xs">Subject: </span>
            <span className="text-gray-300 text-sm">{outreach.email.subject}</span>
          </div>
        )}
        <div className="text-gray-300 text-sm whitespace-pre-wrap break-words">{outreach.email?.body}</div>
      </div>

      <div className="bg-black/30 rounded-lg p-4 border border-gray-700">
        <div className="flex items-center justify-between mb-3">
          <h5 className="text-white font-semibold flex items-center gap-2"><Linkedin className="h-4 w-4 text-ism-teal" />LinkedIn Outreach</h5>
          <CopyButton copied={copiedField === `linkedin-${idx}`} onClick={() => onCopy(linkedinText, `linkedin-${idx}`)} />
        </div>
        <div className="text-gray-300 text-sm whitespace-pre-wrap break-words">{linkedinText}</div>
      </div>
    </div>
  );
};
